import React from 'react';
import CourtFormsLandingContainer from '~/src/containers/CourtFormsLandingContainer';
import RegionalCourtFormContainer from '~/src/containers/RegionalCourtFormContainer/RegionalCourtFormContainer';
import { getIsRegionalPdfSupported } from '~/src/containers/RegionalCourtFormContainer/helpers';
import CourtFormsSearchable from './CourtFormsSearchable';

function CourtFormsTab() {
  const isRegionalPdfSupported = getIsRegionalPdfSupported();

  return (
    <CourtFormsSearchable sticky syncToUrl>
      {isRegionalPdfSupported ? (
        <RegionalCourtFormContainer />
      ) : (
        <CourtFormsLandingContainer />
      )}
    </CourtFormsSearchable>
  );
}

export default CourtFormsTab;
